import { useCallback } from "react"

import {
  buildProductObjCache,
  getProductObjCacheEntry,
  loadProductsWithChildrenForType
} from "shared/lib/product-obj/loadProduct"
import { useEvent } from "shared/lib/useEvent"
import { useRedux } from "shared/lib/useRedux"

import { useProductObjCacheActions } from "./useProductObjCacheActions"

export function useProductObjCache() {
  const { clearProductObjCache, saveProductObjCache } =
    useProductObjCacheActions()
  const { cache } = useRedux(({ productObjCache }) => ({
    cache: productObjCache
  }))

  const getCacheForVariantKey = useCallback(
    (variantKey: string) => getProductObjCacheEntry({ variantKey, cache }),
    [cache]
  )

  const buildCacheForTypes = useEvent((productTypes: string[]) => {
    return Promise.all(
      productTypes
        .filter(productType => !cache[productType])
        .map(productType => {
          return loadProductsWithChildrenForType(productType).then(products => {
            saveProductObjCache({
              productType,
              productTypeCache: buildProductObjCache(products)
            })
          })
        })
    )
  })

  return {
    cache,
    clearProductObjCache,
    saveProductObjCache,
    buildCacheForTypes,
    getCacheForVariantKey
  }
}
